import { getListReportTotalRouteAPI, getListReportTotalRouteExcelAPI } from "../../../api/report";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ParamsReport, ReportTotalRouteState } from "../../../types/report";
import { Constant } from "../../../config/constant";
import { toast } from "react-toastify";

const limit_pagination: any = window.localStorage.getItem("limit_pagination");
const limitPagination = isNaN(Number(limit_pagination))
    ? Constant.PAGE_SIZE
    : Number(limit_pagination);

const initialState = {
    listReport: [],
    loading: false,
    pagination: {
        total: 0,
        per_page: limitPagination,
        current_page: Constant.DEFAULT_PAGE,
        last_page: Constant.DEFAULT_PAGE,
    },
    listRoute: [],
    total_prices: 0,
    total_commissions: 0,
    total_bookings_agent: 0,
    total_real_revenue: 0,
    total_bookings_car_company: 0,
    filter: {
        booking_date: 'false',
        from: '',
        to: '',
        route_id: '',
    }
} as ReportTotalRouteState;

export const reportTotalRouteCompanySlice = createSlice({
    name: 'reportTotalRouteCompany',
    initialState,
    reducers: {
        setFilterBookingDate(state, action: PayloadAction<string>) {
            state.filter.booking_date = action.payload;
        },
        setFilterRangeDate(state, action: PayloadAction<any>) {
            state.filter.from = action.payload?.[0];
            state.filter.to = action.payload?.[1];
        },
        setFilterRoute(state, action: PayloadAction<number | string>) {
            state.filter.route_id = action.payload;
        },
        setPerPage(state, action: PayloadAction<number>) {
            state.pagination.per_page = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getListReportTotalRouteCompany.pending, (state) => {
                state.loading = true;
            }).addCase(getListReportTotalRouteCompany.fulfilled, (state, action) => {
                state.loading = false;
                state.listReport = action?.payload?.data;
                state.pagination.total = action.payload?.pagination?.total;
                state.pagination.per_page = action.payload?.pagination?.per_page;
                state.pagination.last_page = action.payload?.pagination?.last_page;
                state.pagination.current_page = action.payload?.pagination?.current_page;
                state.total_commissions = action.payload?.total_commissions;
                state.total_prices = action.payload?.total_prices;
                state.total_bookings_agent = action.payload?.total_bookings_agent;
                state.total_bookings_car_company = action.payload?.total_bookings_car_company;
                state.total_real_revenue = action.payload?.total_real_revenue;
            }).addCase(getListReportTotalRouteCompany.rejected, (state, action: any) => {
                const listErros = action?.payload?.response?.data?.errors;
                if (listErros) {
                    Object.keys(listErros)?.forEach((fieldName) => {
                        toast.error(`${[listErros[fieldName]]}`);
                    });
                }
                state.loading = false;
            }).addCase(getListReportTotalRouteCompanyExcel.pending, (state) => {
            }).addCase(getListReportTotalRouteCompanyExcel.fulfilled, (state, action) => {
            }).addCase(getListReportTotalRouteCompanyExcel.rejected, (state, action: any) => {
                const listErros = action?.payload?.response?.data?.errors;
                if (listErros) {
                    Object.keys(listErros)?.forEach(fieldName => {
                        toast.error(`${[listErros[fieldName]]}`)
                    })
                }
            })
    }
})

export const getListReportTotalRouteCompany = createAsyncThunk('ReportTotalRouteCompany/getAll', async (params: ParamsReport, {
    dispatch, rejectWithValue
}) => {
    try {
        const response = await getListReportTotalRouteAPI(params)
        if (response) {
            return response?.data;
        }
    } catch (error: any) {
        return rejectWithValue(error);
    }
})

export const getListReportTotalRouteCompanyExcel = createAsyncThunk('ReportTotalRouteCompany/getAllExcel', async (params: ParamsReport, {
    dispatch, rejectWithValue
}) => {
    try {
        const response = await getListReportTotalRouteExcelAPI(params)
        if (response) {
            return response?.data;
        }
    } catch (error: any) {
        return rejectWithValue(error);
    }
})

export const { setFilterBookingDate, setFilterRangeDate, setFilterRoute, setPerPage } = reportTotalRouteCompanySlice.actions;